// extracted by mini-css-extract-plugin
export default {"feedback":"Feedback_feedback__XtWvP","feedbackHeader":"Feedback_feedbackHeader__cQbRz","feedbackBox":"Feedback_feedbackBox__8w7CX","feedbackInput":"Feedback_feedbackInput__Q8qgq"};